// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const filtersOptions = (filters: any, data: any) =>
  filters
    .map((item) => item.id)
    .map((item) => {
      const foo: { [id: string]: { value: string }[] } = {}

      function onlyUnique(value, index, self) {
        return self.indexOf(value) === index
      }

      return {
        ...foo,
        [item]: data.map((row) => row[item]).filter(onlyUnique),
      }
    })
